import angular from 'angular';

angular.module('commonServices').filter('bAnd', function() {
  /*
    Bitwise and operator filter
    usage: number | bAnd:5   <==> (number & 5) === 5
           number | bAnd:5:1 <==> (number & 5) === 1
    */
  return function(firstNumber, secondNumber, compareTo) {
    return (
      (parseInt(firstNumber, 10) & parseInt(secondNumber, 10)) ===
      (typeof compareTo === 'undefined' ? parseInt(secondNumber, 10) : parseInt(compareTo, 10))
    );
  };
});
